import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../../Support/with_presenter';
import {EditTitleFormPresenter} from './EditTitleFormPresenter';

interface OwnProps {
    id: number;
    title: string;
}

const EditTitleFormComponent: FunctionComponent<OwnProps & PresenterProps<EditTitleFormPresenter>> = observer(
    ({presenter, title}) => {
        if (presenter.isEditing) {
            return (
                <h1>
                    <form
                        className="d-flex flex-row justify-content-start"
                        onSubmit={(e) => {
                            e.preventDefault();
                            if (!presenter.isSaving) {
                                presenter.submit();
                            }
                        }}
                    >
                        <input
                            autoFocus
                            disabled={presenter.isSaving}
                            type="text"
                            className="form-control"
                            value={presenter.title}
                            onKeyUp={(e) => {
                                if (e.key === 'Escape') {
                                    presenter.toggleEdit(title);
                                }
                            }}
                            onChange={(e) => {
                                presenter.setTitle(e.target.value);
                            }}
                        />
                        <button type="submit" className="btn btn-link">
                            <i className="bi bi-check"></i>
                        </button>
                    </form>
                </h1>
            );
        }
        return (
            <h1>
                {presenter.isEdited ? presenter.title : title}
                <button
                    className="btn btn-link"
                    onClick={() => presenter.toggleEdit(presenter.isEdited ? presenter.title : title)}
                >
                    <i className="bi bi-pencil"></i>
                </button>
            </h1>
        );
    },
);

export const EditTitleForm = withPresenter<EditTitleFormPresenter, OwnProps>(
    (props, component) => new EditTitleFormPresenter(props.id, component.network.workouts),
    EditTitleFormComponent,
);
